import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import translate from '@/lib/intl/translate';

export type NewDataUploadButtonProps = {
  disabled: boolean;
};

export default function NewDataUploadButton({
  disabled,
}: NewDataUploadButtonProps) {
  return (
    <Tooltip title={disabled ? translate('DATA_UPLOADS_DISABLED_MESSAGE') : ''}>
      <span className="block">
        <Button
          component={RouterLink}
          data-testid="new-data-upload-button"
          disabled={disabled}
          onClick={(e: React.MouseEvent<HTMLElement>) => {
            if (disabled) e.preventDefault();
          }}
          to={AuthRoutes.COMPANY_DATA_UPLOADS_NEW}
          variant="contained"
        >
          {translate('DATA_UPLOADS_NEW_UPLOAD')}
        </Button>
      </span>
    </Tooltip>
  );
}
